<template>
  <div>
    <div class="col-2 content-area">
      <grid-x col="2fr 0.5fr" rows="1fr" gap="2em">
        <div class="col-2-1">
            <div class="widget-buttons">
              <button
                class="pub-buttons"
                v-if="article.status == 'draft' || article.status == 'preview'"
                @click="publishPost();"
              >PUBLISH</button>
              <button
                class="pub-buttons"
                @click="openPreviewModal();"
              >PREVIEW</button>
              <button
                class="pub-buttons"
                v-if="article.status == 'publish' || article.status == 'preview'"
                @click="unpublishPost();"
              >UNPUBLISH</button>
              <button class="pub-buttons" style="margin-right:10px;" @click="savePostData(article)">UPDATE</button>
              <button class="pub-buttons" style="margin-right:10px;" @click="toggleHistoryModal()" v-if="articleKey">HISTORY</button>
              <span v-if="autosaved && article.lastAutosave">AUTOSAVED VERSION {{ $moment(article.lastAutosave.timestamp*1000) | moment("HH:mm DD/MM/YYYY") }}</span>
            </div>
          <h3>Article</h3>
          <div>

            <div class="input-label">Title</div>
            <div class="input-box">
              <input v-model="article.title" type="text" placeholder="Title">
            </div>
            <div v-if="article.layout == 'article-layout-evergreen' && (article.toc && article.toc.length > 0)">
              <h3>Table of contents</h3>
              <ul class="toc">
                <li v-for="(item, index) in article.toc" :key="`item-${index}`">
                  <a :href="item.anchor">{{ item.title }}</a>
                  <ul v-if="item.subContents.length > 0">
                    <li
                      v-for="(subItem, index) in item.subContents"
                      :key="`subitem-${index}`"
                    >
                      <a :href="subItem.anchor">{{ subItem.title }}</a>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
            <div class="editor-area-parent" v-if="article.layout == 'article-layout-evergreen' || article.layout == 'article-layout-featured'">
              <md-tabs @md-changed="changeWidgetsTab">
                <md-tab  id="contentEditor" md-label="Edit Content"></md-tab>
                <md-tab  id="layoutEditor" md-label="Edit Layout"></md-tab>
              </md-tabs>

              <md-content class="editor-area">
                <div v-if="'contentEditor' == currentTab">
                  <div v-for="(item,key) in article.widgets" :key="key">
                    <div style="margin:0 auto;text-align:center;" v-if="item.dropcap">DROPCAP ENABLED</div>
                    <div style="font-size:10px">Widget {{key}}</div>
                    <component 
                      :is="item.type"
                      @changeImage="changeImage($event, item)"
                      @toggle-images-modal="toggleImagesModal"
                      @toggle-dropcap="item.dropcap = !item.dropcap"
                      v-model="item.content"></component>
                  </div>

                </div>
                
                <div v-if="'layoutEditor' == currentTab">
                  <draggable
                  style="width:600px;margin:0 auto;"
                    v-model="article.widgets"
                    @start="drag=true"
                    @end="drag=false"
                  >
                    <div
                      class="draggable-items flex center-flex-y flex-space-between"
                      v-for="(item,key) in article.widgets"
                      :key="key"
                    >
                      <div class="flex center-flex-y">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          class="draggable-icon"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                        >
                          <path fill="none" d="M0 0h24v24H0V0z"></path>
                          <path
                            d="M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
                          ></path>
                        </svg>
                        <span>{{key}} - {{item.type}}</span>
                      </div>
                      <button @click="removeWidget(key)">Remove</button>
                    </div>
                  </draggable>
                </div>

                <div class="flex" style="width: 400px;margin: 0 auto;padding-top:10px;">
                  <div class="input-box down-caret">
                    <select v-model="newWidgetType" placeholder="Current Widget Type">
                      <option disabled value>Widget Type</option>
                      <option value="froala-editor">Text Editor</option>
                      <option value="code-editor">HTML Editor</option>
                      <option value="image-full-width">Full Width Image</option>
                      <option value="video-full-width">Full Width Video</option>
                      <option value="video-scroller">Video Scroller</option>
                      <option value="image-double">Double Image Row</option>
                      <option value="image-featured">Featured Image</option>
                      <option value="featured-quote">Featured Quote</option>
                      <option value="image-standard">Standard Image</option>
                      <option value="image-circle">Circle Image</option>
                    </select>
                  </div>
                  <button @click="createWidget" style="width: 200px;height: 30px;margin-left: 10px;">New Widget</button>
                </div>
              </md-content>

            </div>

            <div class="editor-area-parent" v-if="article.layout == 'article-layout-default' || !article.layout">
              <froala-editor v-model="article.content" @toggle-modal="toggleImagesModal"></froala-editor>
            </div>


            <div style="position: relative;margin-top: 26px;">
              <div class="widget-buttons" style="position: absolute;right: 0;top: -17px;">
                <button
                  class="pub-buttons"
                  v-if="article.status == 'draft' || article.status == 'preview'"
                  @click="publishPost();"
                >PUBLISH</button>
                <button
                  class="pub-buttons"
                @click="articlePreviewModalOpen = true"
                >PREVIEW</button>
                <button
                  class="pub-buttons"
                  v-if="article.status == 'publish' || article.status == 'preview'"
                  @click="unpublishPost();"
                >UNPUBLISH</button>
                <button class="pub-buttons" style="margin-right:10px;" @click="savePostData(article)">UPDATE</button>
                <button class="pub-buttons" style="margin-right:10px;" @click="toggleHistoryModal()" v-if="articleKey">HISTORY</button>
              </div>
              <h2>SEO Scorecard</h2>
              <div class="scorecard">
                <md-list>
                  <md-subheader>Metadata</md-subheader>

                  <md-list-item>
                    <md-checkbox v-model="scorecard" value="titleContainsPhrase" />
                    <span class="md-list-item-text">Title Contains Phrase</span>
                  </md-list-item>

                  <md-list-item>
                    <md-checkbox v-model="scorecard" value="slugContainsPhrase" />
                    <span class="md-list-item-text">Slug Contains Phrase</span>
                  </md-list-item>

                  <md-list-item>
                    <md-checkbox v-model="scorecard" value="seoDescriptionLength" />
                    <span class="md-list-item-text">SEO Description 120-156 Chars</span>
                  </md-list-item>

                  <md-list-item>
                    <md-checkbox v-model="scorecard" value="seoTitleContainsPhrase" />
                    <span class="md-list-item-text">SEO Title Contains Phrase</span>
                  </md-list-item>

                  <md-list-item>
                    <md-checkbox v-model="scorecard" value="seoTitleStartsWithPhrase" />
                    <span class="md-list-item-text">SEO Title Starts With Phrase</span>
                  </md-list-item>

                  <md-list-item>
                    <md-checkbox v-model="scorecard" value="relatedTags" />
                    <span class="md-list-item-text">Similar Phrase In Tags</span>
                  </md-list-item>
                </md-list>
                <md-list>
                  <md-subheader>Images</md-subheader>

                  <md-list-item>
                    <md-checkbox v-model="scorecard" value="containsImage" />
                    <span class="md-list-item-text">At Least 1 Article Image</span>
                  </md-list-item>

                  <md-list-item>
                    <md-checkbox v-model="scorecard" value="imageWithPhraseInAlt" />
                    <span class="md-list-item-text">Image With Phrase In Alt</span>
                  </md-list-item>

                  <md-list-item>
                    <md-checkbox v-model="scorecard" value="imageWithPhraseInCaption" />
                    <span class="md-list-item-text">Image With Phrase In Caption</span>
                  </md-list-item>

                  <md-list-item>
                    <md-checkbox v-model="scorecard" value="imageIsBelowTargetSize" />
                    <span class="md-list-item-text">All Images Sized Appropriately</span>
                  </md-list-item>
                </md-list>
                <md-list>
                  <md-subheader>Content</md-subheader>

                  <md-list-item>
                    <md-checkbox v-model="scorecard" value="phraseInFirst100Words" />
                    <span class="md-list-item-text">Phrase In First 100 Words</span>
                  </md-list-item>

                  <md-list-item>
                    <md-checkbox v-model="scorecard" value="headingWithTargetPhrase" />
                    <span class="md-list-item-text">Heading with target phrase</span>
                  </md-list-item>

                  <md-list-item>
                    <md-checkbox v-model="scorecard" value="phraseMentioned4Times" />
                    <span class="md-list-item-text">Phrase Mentioned x4</span>
                  </md-list-item>

                  <md-list-item>
                    <md-checkbox v-model="scorecard" value="similarPhraseMentioned10Times" />
                    <span class="md-list-item-text">Similar Phrases Mentioned x10</span>
                  </md-list-item>
                </md-list>
              </div>
            </div>
          </div>
        </div>
        <div class="col-2-2" style="min-width: 460px;">
          <div>
            <h3>Status</h3>
            <div>
              <div>Status: {{article.status}}</div>
              <div v-if="article.lastUpdated">Last Updated: {{$moment(article.lastUpdated*1000) | moment("HH:mm DD/MM/YYYY") }}</div>
              <div v-if="article.timestamp">Published: {{$moment(article.timestamp*1000) | moment("HH:mm DD/MM/YYYY") }}</div>
            </div>
            
            <h3>Target Phrase</h3>
            <div class="input-label">Target Phrase</div>
            <div class="flex">
              <div class="input-box">
                <input v-model="article.targetPhrase" type="text" placeholder="Phrase">
              </div>
              <button style="height: 30px;margin-left: 10px;" @click="openTrends(article.targetPhrase)">TRENDS</button>
            </div>
            
            <h3>Meta</h3>
            <div class="input-label">Slug</div>
            <div :class="'input-box slug-input ' + slugValid">
              <input
                v-model="article.slug"
                @input="checkSlug"
                type="text"
                placeholder="Slug"
              >
              <span style="padding-top: 5px;padding-right: 5px;">{{slugValid}}</span>
            </div>
            <div class="input-label">Author</div>
              <div class="input-box">
                <md-autocomplete v-model="article.authorSlug" :md-options="authors || []" @md-changed="getAuthors" @md-opened="getAuthors">
                  <label></label>

                  <template slot="md-autocomplete-empty" slot-scope="{ term }">
                    No Authors matching "{{ term }}" were found.
                  </template>

                  <template slot="md-autocomplete-item" slot-scope="{ item }"><span style="font-size:initial;">{{ item }}</span></template>
                </md-autocomplete>
            </div>
            <div v-if="article.meta">
              <div class="input-label">Social Title</div>
              <div class="input-box">
                <input v-model="article.meta['og:title']" type="text" placeholder="Title">
              </div>
            </div>
            <google-preview v-model="article.meta" :slug="article.slug" style="margin-bottom:10px;"></google-preview>
            <!-- <div class="input-label">Tags</div>
            <input-tag v-model="article.tags" placeholder="Enter tags"></input-tag>-->
            <!-- ASK IF TAGS WILL BE IMPORTED FROM FIREBASE -->
            <div v-if="showTags">
              <div class="input-label">Tags</div>
              <div class="input-box tag-input-container" style="height:auto;">
                <tag-input :options="tags" placeholder="Enter tags" :value="article.tags" :multiple="true" @value="setTags" v-if="showTags"></tag-input>
              </div>
            </div>
            <div class="input-label">Select Category</div>
            <div class="input-box down-caret" v-if="showCategory">
              <select v-model="article.parentCategory" @change="updateSubcategories">
                <option
                  v-for="(item,key) in categories"
                  :key="key"
                  :value="item"
                >{{ item }}</option>
              </select>
            </div>
            <div class="input-box down-caret" v-if="subCategories">
              <select v-model="article.subCategory">
                <option
                  v-for="(subitem,subkey) in subCategories"
                  :key="subkey"
                  :value="subitem"
                >{{ subitem }}</option>
              </select>
            </div>
            <div class="input-label">Select Layout</div>
            <div class="input-box down-caret">
              <select v-model="article.layout">
                <option
                  v-for="(layout,layoutkey) in layouts"
                  :key="layoutkey"
                  :value="layout"
                >{{ layout }}</option>
              </select>
            </div>


            <div>
              <h3>Branded Details</h3>
              <div v-if="!article.sponsored_post_data">
                <button @click="article.sponsored_post_data = {brand_name: '',brand_image_url:''}">Enable Branding</button>
              </div>
              <div v-if="article.sponsored_post_data">
                <div class="input-label">Link</div>
                <div class="input-box">
                  <input v-model="article.sponsored_post_data.brand_image_click_link" type="text" placeholder="Link">
                </div>
                <div class="input-label">Brand Name</div>
                <div class="input-box">
                  <input v-model="article.sponsored_post_data.brand_name" type="text" placeholder="Brand Name">
                </div>
                <div class="input-label">Brand Text</div>
                <div class="input-box" style="height:100px;">
                  <textarea style="height:100px;" v-model="article.sponsored_post_data.brand_text" type="text" placeholder="Brand Text"></textarea>
                </div>
                <img
                  v-if="article.sponsored_post_data.brand_image_url"
                  :src="article.sponsored_post_data.brand_image_url"
                >
                <div class="flex" style="margin-top:10px;">
                  <button @click="toggleImagesModal({type: 'branded'})">Change Image</button>
                </div>
                <button @click="article.sponsored_post_data = false" style="margin-top:10px;">Remove Branding</button>
              </div>

            </div>

            <div class="images">
              <div class="featured-images">
                <h3>Featured Image</h3>
                <div v-if="article.image && article.image.desktop" style="">
                  <div>Desktop</div>
                  <img :src="article.image.desktop" />
                </div>
                <div v-if="article.image && article.image.mobile" style="margin-top:10px">
                  <div>Mobile</div>
                  <img :src="article.image.mobile" />
                </div>
                <div class="flex" style="margin-top:10px;">
                  <button @click="toggleImagesModal({type: 'preview-' + article.layout})">Change Image</button>
                </div>
              </div>
              <div class="social-images">
                <h3>Social Image</h3>
                <img
                  v-if="article.socialImage"
                  :src="article.socialImage"
                >
                <div class="flex" style="margin-top:10px;">
                  <button @click="toggleImagesModal({type: 'social'})">Change Image</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </grid-x>

      <modal-history
        ref="modalhistory" 
        v-if="historyModalOpen"
        :id="articleKey"
        @restore="replaceArticle" 
        @close="historyModalOpen = false"></modal-history>

      <modal-article-preview
        ref="modalarticlepreview" 
        v-if="articlePreviewModalOpen"
        :slug="article['slug']"
        :password="article['password']"
        @close="articlePreviewModalOpen = false"></modal-article-preview>

      <modal-image-workflow ref="imageWorkflow"></modal-image-workflow>

        
    </div>
  </div>
</template>
<style>
.input-box .md-field.md-theme-default:after {
  display: none !important
}
.input-box .md-field {
  margin: 8px 6px 24px !important;
}
.ace_text-input {
  position: absolute!important;
}
    
.ic-fb_uploader ul {
  display: none;
}
.editor-area-parent .md-tab-nav-button, .editor-area {
  background-color: #3d3d3d !important;
}
</style>
<style scoped>
ul.toc {
  margin: 0;
  font-size: rem(14);
  color: #898989;
  list-style: disc;
  padding-left: 20px;
}
ul.toc > li {
  line-height: 1.75;
}

.editor-area {
  padding: 10px;
}
.editor-area-parent {
  margin-top:20px;
  margin-bottom:40px;
}
#fb-editor {
  margin-top: 20px;
  color: black;
}
.featured-images img {
  width: 100%;
}
.ic-fb_uploader {
  width: 100px;
  overflow: hidden;
  margin-top: 0;
}

    

.input-textarea.input-box {
  height: 82px;
}
.input-textarea textarea {
  height:100%;
}
.slug-input.invalid {
  border: 1px solid red;
}
.slug-input.invalid span {
  color: red;
}
.slug-input.valid {
  border: 1px solid green;
}
.slug-input.valid span {
  color: green;
}
.slug-input.searching {
  border: 1px solid yellow;
}
.pub-buttons {
  float: right;
  margin-left: 5px;
}
.scorecard > .md-list {
  width: 320px;
  max-width: 100%;
  height: 400px;
  display: inline-block;
  overflow: auto;
  background-color:#3d3d3d !important;
  vertical-align: top;
}
table {
  font-family: "Arial";
  margin: 25px auto;
  border-collapse: collapse;
  border: 1px solid #eee;
  border-bottom: 2px solid #00cccc;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1), 0px 10px 20px rgba(0, 0, 0, 0.05),
    0px 20px 20px rgba(0, 0, 0, 0.05), 0px 30px 20px rgba(0, 0, 0, 0.05);
}
table tr:hover {
  background: #f4f4f4;
}
table tr:hover td {
  color: #555;
}
table th,
table td {
  color: #fff;
  border: 1px solid #eee;
  padding: 12px 35px;
  border-collapse: collapse;
}
table th {
  background: #00cccc;
  color: #fff;
  text-transform: uppercase;
  font-size: 12px;
}
table th.last {
  border-right: none;
}
select option {
  color: black;
}
</style>

<script>
/*
  TODO:
    Create post button pieces together html and creates a post object
      Implement Form render outputting HTML for the above
      Prevent slug collisions
    Save to posts database
      Save format for form builder / froala content
    Data validation
    View Results
      Preview of data in table (first 20 rows?)
        Ability to delete a row (test data)
      Export all data to CSV
*/

import Vue from "vue";
import firebase from "firebase";
import gridX from "../common/gridX";
import draggable from "vuedraggable";
import config from "../../config.json";
import TagInput from "../common/atoms/TagInput";
import Multiselect from "vue-multiselect";

import ModalHistory from "../modals/history.vue";
import ModalArticlePreview from "../modals/articlePreview.vue";
import ModalImageWorkflow from "../modals/imageWorkflow.vue";

import FroalaEditor from "./articleWidgets/Froala";
import CodeEditor from "./articleWidgets/CodeEditor";
import imageFullWidth from "./articleWidgets/imageFullWidth";
import videoFullWidth from "./articleWidgets/videoFullWidth";
import videoScroller from "./articleWidgets/videoScroller";
import imageDouble from "./articleWidgets/imageDouble";
import imageFeatured from "./articleWidgets/imageFeatured";
import imageStandard from "./articleWidgets/imageStandard";
import imageCircle from "./articleWidgets/imageCircle";
import FeaturedQuote from "./articleWidgets/FeaturedQuote";
import GooglePreview from "./articleWidgets/GooglePreview";

export default {
  components: {
    gridX,
    draggable,
    FroalaEditor,
    CodeEditor,
    imageFullWidth,
    videoFullWidth,
    videoScroller,
    imageDouble,
    imageFeatured,
    imageStandard,
    imageCircle,
    FeaturedQuote,
    GooglePreview,
    ModalHistory,
    ModalArticlePreview,
    ModalImageWorkflow,
    TagInput,
    Multiselect
  },
  props: [

  ],
  data: function() {
    return {
      article: {
        sponsored_post_data:false,
        layout: "article-layout-default",
        widgets: [],
        meta: {
          title: "",
          description: ""
        }
      },
      results: [],
      authors: [],
      articleObject: false,
      articleKey: "",
      newPost: {
        layout: "article-layout-default",
        newPost: "draft",
        type: "post",
        tags: [],
        widgets: [],
        seoPhrase: "",
        status: "draft",
        slug: "",
        meta: {
          title: "",
          description: ""
        }
      },

      scorecard: [],
      storage: firebase.storage(),
      sourceFroala: null,
      imagesModalOpen: false,
      formBuilder: null,
      //article: false,
      currentTab: "post",
      showNewPost: false,
      autosaved: false,
      categoryChanged: false,
      newWidgetType: false,
      debounceSlug: false,
      checkSlugRandom: null,
      autosaver: null,
      showTags: true,
      slugValid: "",
      lastArticleData: {},
      changeCat: false,
      photopeaCallback: false,
      photopeaImageUrl: "",
      photopeaModalOpen: false,
      historyModalOpen: false,
      articlePreviewModalOpen: false,
      layouts: [
        "article-layout-default",
        "article-layout-evergreen",
        "article-layout-featured"
      ],
      categories: [],
      tags: [],
      subCategories: null,
      showCategory: false,
      showTags: false,
      cropRatio: "article"
    };
  },
  mounted: function() {
    this.showCategory = false;
    this.showTags = false;
    this.tags = [];
    if(window.globalUser && !this.article.authorSlug) {
      this.article.authorSlug = window.globalUser.defaultAuthor;
    }

    firebase.firestore()
      .collection("categories")
      .get()
      .then((querySnap) => {
        querySnap.forEach((catSnap) => {
          this.categories.push(catSnap.id);
        });
        this.showCategory = true;
      });
    firebase.firestore()
      .collection("tags")
      .get()
      .then((querySnap) => {
        querySnap.forEach((tagSnap) => {
          this.tags.push(tagSnap.id);
        });
        this.showTags = true;
      });
  },
  destroyed: function() {
    clearInterval(this.autosaver);
    clearInterval(this.seoScorecardInterval);
  },
  // watch: {
  //   article: {
  //     handler: function() {

  //     },
  //     deep: true
  //   }
  // },
  methods: {
    loadArticle: function(key) {
      firebase.firestore().collection("postContent")
        .doc(key)
        .get()
        .then((doc) => {
          var postData = doc.data();
          if(!postData) {
            alert("Article not found!");
            this.$emit("not-found");
            throw 1;
          } else {
            firebase.firestore().collection("autosaves")
              .doc(key)
              .get()
              .then((doc) => {
                var autosaveData = doc.data();
                console.log(autosaveData);
                console.log("vs");
                console.log(postData);
                if(autosaveData && autosaveData.lastAutosave && autosaveData.lastAutosave.timestamp > postData.lastUpdated) {
                  this.autosaved = true;
                  this.articleKey = key;
                  this.article = autosaveData;
                } else {
                  this.articleKey = key;
                  this.article = postData;
                }
                this.lastArticleData = JSON.stringify(this.article);
                this.initialiseArticle();
              });
          }
        });
    },
    createTableOfContents: function() {
      var toc = [];
      var tocCount = 0;
      this.article.widgets.forEach((widget) => {
        if(widget.type == "froala-editor") {
          console.log(widget.content);
          var ele = $("<div>" + widget.content + "</div>");
          ele.find("h2, h3").each(function (index) {
            console.log("found h2/h3", $(this));
            var id = "toc-pos-" + tocCount;
            tocCount++;
            $(this).attr("id", id);
            console.log($(this).prop('nodeName'));
            switch($(this).prop('nodeName')) {
              case "H2":
                toc.push({
                  title: $(this).text(),
                  anchor: "#" + id,
                  subContents: []
                });
                break;
              case "H3":
                if(toc.length == 0) {
                  alert("The table of contents requires the first heading to be a h2, not a h3");
                  throw 1
                }
                toc[toc.length-1].subContents.push({
                  title: $(this).text(),
                  anchor: "#" + id
                });
                break;
            }
          });
          widget.content = ele.html();
        }
      });
      Vue.set(this.article, "toc", toc);
      
      console.log(this.article);
    },
    changeImage: function(imageObject, item) {
      console.log(this.$refs['imageWorkflow']);
      console.log(imageObject, item);
      this.$refs['imageWorkflow'].process(imageObject.callback, item);
    }, 
    completeEditImage: function(imageUrl) {
      this.photopeaCallback(imageUrl);
    },
    changeWidgetsTab: function(tab) {
      this.currentTab = tab;
    },
    openPreviewModal: function() {
      if(!this.article.password) {
        this.article.password = Math.round(Math.random() * 99999999);
        firebase.firestore().collection("posts")
          .doc(this.articleKey)
          .update({
            password: this.article.password
          });
        firebase.firestore().collection("postContent")
          .doc(this.articleKey)
          .update({
            password: this.article.password
          }).then(() => {
            this.articlePreviewModalOpen = true
          })
      } else {
        this.articlePreviewModalOpen = true
      }
      
    },
    getAuthors: function(searchTerm) {
      this.authors = new Promise(resolve => {
        if (!searchTerm) {
          resolve([])
        } else {
          searchTerm = searchTerm.toLowerCase().replace(/\s/g, '-').replace(/[^a-z0-9\-]+/gi, '');
          var strlength = searchTerm.length;
          var strFrontCode = searchTerm.slice(0, strlength-1);
          var strEndCode = searchTerm.slice(strlength-1, searchTerm.length);

          var startcode = searchTerm;
          var endcode= strFrontCode + String.fromCharCode(strEndCode.charCodeAt(0) + 1);
          console.log(startcode, endcode, searchTerm);
          firebase.firestore()
            .collection("authors")
            .where('slug', '>=', startcode)
            .where('slug', '<', endcode)
            .limit(20)
            .get()
            .then((snap) => {
              var data = snap.docs.map((documentSnapshot) => {
                return documentSnapshot.data().slug;
              });
              console.log(data);
              resolve(data);
            });
        }
      })
    },
    openTrends: function(trend) {
      window.open(`https://trends.google.com/trends/explore?date=now%201-d&geo=AU&q=${trend}`, '_blank');
    },
    toggleHistoryModal: function() {
      this.historyModalOpen = !this.historyModalOpen
    },
    toggleImagesModal: function(typeObject) {
      console.log("toggle 2");
      this.$refs['imageWorkflow'].process((image) => {
        console.log(image.mobile);
        if(typeObject.type == 'social') {
          Vue.set(this.article, "socialImage", image.mobile);
        } else if(typeObject.type == 'preview-article-layout-default' || typeObject.type == 'preview-article-layout-featured' || typeObject.type == 'preview-article-layout-evergreen') {
          Vue.set(this.article, "image", image);
        } else if(typeObject.type == 'branded') {
          Vue.set(this.article.sponsored_post_data, "brand_image_url", image.mobile);
        } else if(typeObject.callback) {
          typeObject.callback(image);
        }
      }, typeObject);
    },
    updateSubcategories: function() {
      this.subCategories = null;
      console.log(this.article.parentCategory);
      firebase.firestore()
        .collection("categories")
        .doc(this.article.parentCategory)
        .get()
        .then((docSnap) => {
          var data = docSnap.data();
          console.log(data);
          var temp = [];
          data.subcategories.forEach((subcat) => {
            temp.push(subcat.name);
          });

          Vue.set(this, "subCategories", temp);
        });
    },
    checkSlug: function() {
      if (this.debounceSlug) clearTimeout(this.debounceSlug);
      this.slugValid = "searching";
      this.debounceSlug = setTimeout(() => {
        let localCheckSlugRandom = Math.random();
        this.checkSlugRandom = localCheckSlugRandom;
        firebase.firestore()
          .collection("posts")
          .where("slug", "==", this.article.slug)
          .get()
          .then(querySnapshot => {
            if (localCheckSlugRandom != this.checkSlugRandom) return;
            if (!querySnapshot.empty) {
              var valid = true;
              querySnapshot.forEach((doc) => {
                if(doc.id != this.articleKey) valid = false;
              });
              if(!valid) this.slugValid = "invalid";
              else this.slugValid = "valid";
            } else {
              this.slugValid = "valid";
            }
          });
      }, 500);
    },
    newImage: function(imageData) {
      console.log("new image", imageData);;
      switch(imageData.type) {
        case "preview":
            Vue.set(this.article, "image", imageData.url);
            break;
        case "social":
            Vue.set(this.article, "socialImage", imageData.url);
            break;
        case "article":
            this.sourceFroala.html.insert(`<img src="${imageData.url}" />`);
            break;
      }
    },
    createWidget: function() {
      var obj = {};
      switch(this.newWidgetType) {
        case "image-double": 
          obj = {
            content: {
              objects: [
                {image: {mobile: ""}, caption: "", source: ""},{image: "", caption: "", source: ""}
              ]
            },
            type: this.newWidgetType
          }
          break;
        case "image-featured": 
          obj = {
            content: {
              image: {mobile: ""}, 
              caption: "",
              source: "",
              wysiwyg: ""
            },
            type: this.newWidgetType
          }
          break;
        case "featured-quote":
          obj = {content: {quote: "", wysiwyg: ""}, type: this.newWidgetType};
          break;
        case "video-full-width":
          obj = {content: {mediaId: "", title: "", subtitle: "", image: {mobile: ""}}, type: this.newWidgetType};
          break;
        case "video-scroller":
          obj = {content: {url: "", thumbnail: "", videoDuration:0, items: [""]}, type: this.newWidgetType};
          break;
        case "image-circle":
          obj = {content: {image: {mobile: ""}, caption: "", source: "", decorationStyle: "option-1"}, type: this.newWidgetType};
          break;
        case "image-full-width":
          obj = {content: {image: {mobile: ""}, caption: "", source: "", captionStyle: "layout-1"}, type: this.newWidgetType};
          break;
        case "image-standard":
          obj = {content: {image: {mobile: ""}, caption: "", source: ""}, type: this.newWidgetType};
          break;
        default: 
          obj = {content: '', type: this.newWidgetType};
          break;
      }
      this.article.widgets ? this.article.widgets.push(obj) : this.article.widgets = [obj];
    },
    initialiseArticle: function(currentData) {
      this.showTags = false;
      setTimeout(() => {
        console.log(currentData);
        if(this.article.parentCategory)
          this.updateSubcategories();

        this.showTags = true;
        this.lastArticleData = JSON.stringify(this.article);
        console.log(this.article);
        this.seoScorecard();
        this.seoScorecardInterval = setInterval( () => {
          this.seoScorecard();
        },4000);
        return;
        this.autosaver = setInterval( () => {
          
          console.log("checking")
          // If the object has changed
            
            var tempObj = JSON.stringify(this.article);

          if(this.lastArticleData != tempObj && (tempObj.title != "" || tempObj.content  != "" || (tempObj.widgets && tempObj.widgets.length > 0))) {

            tempObj = JSON.parse(tempObj);
            this.autosaved = true;
            console.log("AUTOSAVING");

            tempObj.lastAutosave = this.article.lastAutosave = {
              timestamp: Math.floor(Date.now()/1000),
              user: firebase.auth().currentUser.uid
            }

            // If the article doesn't have a key, give it one
            if(!this.articleKey) {
              this.articleKey = firebase.firestore().collection("posts").doc().id;
            }

            // Need to save the uploaded object to autosave temp object
            this.lastArticleData = JSON.stringify(tempObj);

            firebase.firestore().collection("autosaves")
              .doc(this.articleKey)
              .set(tempObj);
          }
        }, 6000 );
      }, 10);
    },
    activeClass: function(a, b) {
      if (a == b) return "active";
      return "";
    },
    replaceArticle: function(newData) {
      console.log(newData);
      clearInterval(this.autosaver);
      this.article = newData;
      this.initialiseArticle();
    },
    savePostData: function() {
      var errorMessage = "";
      if (!this.article["slug"]) {
        errorMessage = "Missing Post Slug";
      }
      if (!this.article.title) {
        errorMessage = "Post Title is missing";
      }
      if (!this.article.parentCategory) {
        errorMessage = "Post Category is missing";
      }
      if (!this.article.subCategory) {
        errorMessage = "Post Subcategory is missing";
      }
      if (!this.article.tags || this.article.tags.length == 0) {
        errorMessage = "You must select at least one tag";
      }
      if (errorMessage) {
        console.log(this.article);
        alert(errorMessage);
        return false;
      }
      switch(this.article.layout) {
        default:
        case "article-layout-default":
          break;
        case "article-layout-evergreen":
          this.createTableOfContents();
        case "article-layout-featured":
          this.article.widgets.forEach((widget) => {
            switch(widget.type) {
              case "froala-editor":
                var $div = $("<div>" + widget.content + "</div>");
                $div.find('p[data-f-id="pbf"]').remove();
                widget.content = $div.html();
                break;
              case "image-featured":
                var $div = $("<div>" + widget.content.wysiwyg + "</div>");
                $div.find('p[data-f-id="pbf"]').remove();
                widget.content.wysiwyg = $div.html();
                break;
              case "featured-quote":
                var $div = $("<div>" + widget.content.wysiwyg + "</div>");
                $div.find('p[data-f-id="pbf"]').remove();
                widget.content.wysiwyg = $div.html();
                break;
              case "video-scroller":
                widget.content.items.forEach((html,index) => {
                  var $div = $("<div>" + html + "</div>");
                  $div.find('p[data-f-id="pbf"]').remove();
                  widget.content.items[index] = $div.html();
                });
                break;
            }

          })
          break;
      }
      

      this.article.lastUpdated = Math.floor(Date.now()/1000);
      this.article.lastAutosave = false;
      this.article.categories = [
        this.article.parentCategory,
        this.article.subCategory
      ];
      this.article.editedBy = {
        timestamp: Math.floor(Date.now()/1000),
        user: window.globalUser.email,
        uid: firebase.auth().currentUser.uid
      }
      this.lastArticleData = JSON.stringify(this.article);

      var tempObj = JSON.parse(this.lastArticleData);

      if(!this.articleKey) {
        this.articleKey = firebase.firestore().collection("posts").doc().id;
      }

      var promises = [];

      promises.push(
        firebase.firestore().collection("postContent")
          .doc(this.articleKey)
          .set(tempObj)
      )

      promises.push(
        firebase.firestore().collection("postContent")
          .doc(this.articleKey)
          .collection("history")
          .add(tempObj)
      );

      

      delete tempObj["widgets"];
      delete tempObj["content"];
      promises.push(
        firebase.firestore().collection("posts")
          .doc(this.articleKey)
          .set(tempObj)
      )
      promises.push(
        firebase.firestore().collection("autosaves").doc(this.articleKey).delete()
      )
      return Promise.all(promises);
    },
    onUploadedPostImage: function(e, attrib) {
      e.getDownloadURL().then(url => {
        this.article[attrib] = url;
      });
    },
    onUpload: function(e) {
      e.doUpload();
    },
    onDelete: function(e) {
      e.doDelete();
    },
    getFileName: function(file) {
      return file.name + Math.floor(Math.random() * 1000);
    },
    publishPost: function() {
      var result = this.savePostData();
      if (!result) return;
      var published = Math.floor(Date.now()/1000);
      result.then(() => {
        firebase.firestore().collection("posts")
          .doc(this.articleKey)
          .update({
            status: "publish",
            timestamp: published,
            lastUpdated: published
          });
        firebase.firestore().collection("postContent")
          .doc(this.articleKey)
          .update({
            status: "publish",
            timestamp: published,
            lastUpdated: published
          }).then(() => {
            this.loadArticle(this.articleKey);
          })
      })

      // set published true
    },
    unpublishPost: function() {
      var confirm = window.confirm(
        "Are you sure you would like to UNPUBLISH this post? The page URL will no longer function."
      );
      var result = this.savePostData();

      if (confirm) {
        result.then(() => {
          firebase.firestore().collection("posts")
            .doc(this.articleKey)
            .update({
              status: "draft",
              lastUpdated: Math.floor(Date.now()/1000)
            });
          firebase.firestore().collection("postContent")
            .doc(this.articleKey)
            .update({
              status: "draft",
              lastUpdated: Math.floor(Date.now()/1000)
            }).then(() => {
              this.loadArticle(this.articleKey);
            })
        });
        
      }

      // set published false
    },
    removeWidget: function(key) {
      var confirm = window.confirm(
        "Are you sure you would like to delete this widget?"
      );
      if (confirm) {
        this.article.widgets.splice(key,1);
      }
    },
    seoScorecard: function(){
      this.scorecard = [];
      if(this.article.targetPhrase){
        var basePhrase = this.article.targetPhrase.toLowerCase();
        //Check if Title contains target phrase
        if(this.article.title){
          var currentTitle = this.article.title.toLowerCase();
          if(currentTitle.includes(basePhrase)){
            this.scorecard.push('titleContainsPhrase');
          }
        }
          //Check if slug contains target phrase
        if(this.article.slug){
          var currentSlug = this.article.slug.replace(/-/g,' ');
          if(currentSlug.includes(basePhrase)){
            this.scorecard.push('slugContainsPhrase');
          }
        }
        if(this.article.meta.title){
            //Check if SEO Title contains target phrase
          var currentSeoTitle = this.article.meta.title.toLowerCase();
          if(currentSeoTitle.includes(basePhrase)){
            this.scorecard.push('seoTitleContainsPhrase');
          }
            //Check if SEO Title starts with target phrase
          if(currentSeoTitle.startsWith(basePhrase)){
            this.scorecard.push('seoTitleStartsWithPhrase');
          }
        }
        if(this.article.tags && this.article.tags.length > 0) {
          var relatedTagsCount = 0;
          var testPhraseArray = this.article.targetPhrase.split(" ");
          var arrayLength = testPhraseArray.length;
          var tagsLength = this.article.tags.length;

          for (var i = 0; i < arrayLength; i++) {
            for(var z = 0; z < tagsLength; z++){
              if(this.article.tags[z].includes(testPhraseArray[i].toLowerCase())){
                relatedTagsCount++;
              }
            }
          }
          if(relatedTagsCount > 0){
            this.scorecard.push('relatedTags');
          }
        }

      
      }
        //Check if SEO description is between 120-156 characters
      if(this.article.meta.description){
        var descCharacters = this.article.meta.description.length;
        // if(descCharacters < 120){
        //   alert('The SEO description is too short');
        // }else if(descCharacters > 156){
        //   alert('The SEO description is too long');
        // } else {
        //   this.scorecard.push('seoDescriptionLength');
        // }
        if(descCharacters > 119 && descCharacters < 157){
          this.scorecard.push('seoDescriptionLength');
        }
      }

    },
    setTags: function(value) {
      this.article.tags = value;
    }
  }
};
</script>



// WEBPACK FOOTER //
// articleEditor.vue?540759bc